import React, { Component } from 'react';
import { EventEmitter } from 'events';
import CreateEventWizard from './CreateEventWizard';
import struct from 'observ-struct';
import observ from 'observ';

export default function (api, socket, store) {
    var encoderBus = new EventEmitter();
    socket.encoders(function onData (data) {
        if (data.action.type == 'update') data.action.type = 'edit';
        encoderBus.emit(data.action.type, data);
    });

    var encStore = struct({
        isResolving: observ(false),
        data: observ([])
    });

    var state = struct({
        isResolving: observ(false),
        encoders: encStore
    });

    var actions = {
        add: function (opts, cb) {
            var self = this;
            state.isResolving.set(true);
            api.events.add(opts, function (err, resp) {
                state.isResolving.set(false);
                if (err) {
                    self.props.emitSnack({
                        type: 'error',
                        message: err.message
                    });
                    return cb(err);
                }
                cb(null, resp);
            });
        },

        getEncoders: function () {
            state.encoders.isResolving.set(true);
            api.encoders.get({}, function (err, resp) {
                state.isResolving.set(false);
                if (err) {
                    return self.props.emitSnack({
                        type: 'error',
                        message: err.message
                    });
                }
                state.encoders.set({
                    data: resp.data
                });
                // cb(null, resp);
            });
        },
    };

    return class CreateController extends Component {
        constructor (props) {
            super(props);

            this.state = state();
        }

        componentWillMount () {
            var self = this;
            this.removeListener = state(function onChange (data) {
                self.setState(data);
            });
        }

        componentWillUnmount () {
            this.removeListener();
        }

        componentDidMount () {
            // encApi.actions.get();
            actions.getEncoders();
        }

        render () {

            let actns = { add: actions.add.bind(this) };
            return <CreateEventWizard
                {...store}
                {...this.props}
                {...this.state}
                actions={actns}
            />;
        }
    };
}
